export interface RCSAEntityMainDataModel {
  // 
  can_submit: boolean
  can_edit: boolean
  name: string;
  status_rcsa: string;
  status_penanganan: string;
  risk_code: string;
  criteria: any;
  pelaksanaan_mitigasi_risiko: string;
  realisasi_persentase: number;
  target_mitigasi_persentase: number;
  entity_name: string;
  draft: any;
  // 
  ulid: string;
  ulid_realisasi: string;
  code: string;
  created_at: string;
  updated_at: string;
  status: string;
  properties?: any;
  tanggal: string;
  no: string;
  status_risiko: string;
  risiko_atau_peluang: string;
  id_risiko_utama: number | string;
  id_risiko_agregat: number | string;
  id_risiko: number;
  kategori: string;
  sasaran_korporat: string;
  sasaran_bidang: string;
  sasaran_proses_kerja: string;
  proses_kerja: string;
  deskripsi_risiko_atau_peluang: string;
  kelas_risiko: string;
  penyebab_internal: string;
  penyebab_eksternal: string;
  pengendalian_internal: string;
  indikator_risiko: string;
  dampak: string;
  parameter_dampak_inherent: number;
  nilai_dampak_inherent: number;
  deskripsi_dampak_inherent: number;
  parameter_kemungkinan_inherent: number;
  nilai_kemungkinan_inherent: number;
  deskripsi_kemungkinan_inherent: number;
  tingkat_risiko_inherent: number;
  tingkat_risiko_eksisting: number;
  risk_score: number;
  rencana_mitigasi_risiko: string;
  biaya_implementasi: string;
  biaya_kerugian_dasar: string;
  biaya_kerugian_residual: string;
  cost_benefit_analysis: string;
  pilihan_perlakuan_risiko: string;
  pengukuran_dampak_target: number;
  pengukuran_kemungkinan_target: number;
  tingkat_risiko_target: number;
  target_mitigasi: Targetmitigasi[];
  files: Uploadevidencefile[];
}
interface Uploadevidencefile {
  ulid: string;
  filename: string;
  path: string;
  formatted_file_size: string;
  bulan?: string
}
interface Targetmitigasi {
  bulan: string;
  persentase: number;
  nilai_dampak: number;
  nilai_kemungkinan: number;
  tingkat_risiko: number;
  risk_score: number;
  created_at: string;
  updated_at: string;
}

export interface RCSADependencyDataModel {
  user_id: string;
  entity_id: string;
  entity_pi: any[];
  position_id: string;
  position_name: string;
  division_name: string;
  directorate_name: string;
  project_assignment_id: string;
  period_id: string;
  period_code: string;
  period_name: string;
  assignment_information: any;
  taxonomy: any;
  criteria: any;
  default_status_active: any;
  scoring: any
}

export interface RCSAPICModel {
  user_id: string;
  user_name: string;
  position_id: string;
  position_name: string;
  entity_id: string;
  entity_name: string;
  role_title: string;
}

export interface RCSAUnitModel {
  unit_id: string;
  unit_name: string;
  detail: any;
}

export interface RCSAIncidentModel {
  count_incident: number;
  sum_loss_amount: number;
}

export interface RCSAMonitoringDetailModel {
  entity_name: string;
  pemantauan: any;
  ulid?: string | undefined;
  ulid_realisasi?: string | null;
  history_realisasi_mitigasi: any[];
  target_mitigasi: any;
  realisasi: number;
  target_tingkat_risiko_existing: string;
  realisasi_tingkat_risiko_existing: string;
  pelaksanaan_mitigasi_risiko: string;
  pengendalian_internal: string;
  realisasi_mitigasi: any;
  files: any[];
  informasi_umum: RCSAEntityMainDataModel;
  properties?: any;
  frekuensi: number;
  nilai_kerugian_riil: string;
}

export interface RCSAEntityModel {
  main: {
    data: RCSAEntityMainDataModel[];
    total: number;
  };
  monitoring: {
    data: RCSAEntityMainDataModel[];
    total: number;
  };
  rcsaDetail: {
    data: RCSAEntityMainDataModel;
  };
  dependency: {
    data: RCSADependencyDataModel;
    total: number;
  };
  pic: {
    data: RCSAPICModel[];
    total: number;
  };
  unit: {
    data: RCSAUnitModel[];
    total: number;
  };
  incident: {
    data: RCSAIncidentModel;
  };
  riskIndicator: {
    data: RCSAPICModel[];
    total: number;
  };
  detailMonitoring: {
    data: RCSAMonitoringDetailModel;
  }
}

export enum RCSAEntityActionType {
  GetAllRCSAEntity = "⌘➝RCSA➝Entity➝GetAllRCSAEntity",
  GetAllRCSAMonitoring = "⌘➝RCSA➝Entity➝GetAllRCSAMonitoring",
  GetDetailRCSAEntity = "⌘➝RCSA➝Entity➝GetDetailRCSAEntity",
  GetDependencyEntity = "⌘➝RCSA➝Entity➝GetDependencyEntity",
  GetUnitRCSAEntity = "⌘➝RCSA➝Entity➝GetUnitRCSAEntity",
  GetIncidentRCSAEntity = "⌘➝RCSA➝Entity➝GetIncidentRCSAEntity",
  GetPICEntity = "⌘➝RCSA➝Entity➝GetPICEntity",
  GetRiskIndicator = "⌘➝RCSA➝Entity➝GetRiskIndicator",
  GetDetailRCSAMonitoring = "⌘➝RCSA➝Entity➝GetDetailRCSAMonitoring",
}

export type RCSAEntityAction =
  | {
      data: {
        data: RCSAEntityMainDataModel[];
        total: number;
      };
      type: RCSAEntityActionType.GetAllRCSAEntity;
    }
  | {
      data: {
        data: RCSAEntityMainDataModel[];
        total: number;
      };
      type: RCSAEntityActionType.GetAllRCSAMonitoring;
    }
  | {
      data: {
        data: RCSADependencyDataModel;
        total: number;
      };
      type: RCSAEntityActionType.GetDependencyEntity;
    }
  | {
      data: {
        data: RCSAPICModel[];
        total: number;
      };
      type: RCSAEntityActionType.GetPICEntity;
    }
  | {
      data: {
        data: RCSAEntityMainDataModel;
      };
      type: RCSAEntityActionType.GetDetailRCSAEntity;
    }
  | {
      data: {
        data: RCSAUnitModel[];
        total: number;
      };
      type: RCSAEntityActionType.GetUnitRCSAEntity;
    }
  | {
      data: {
        data: RCSAPICModel[];
        total: number;
      };
      type: RCSAEntityActionType.GetRiskIndicator;
    }
  | {
      data: {
        data: RCSAIncidentModel;
      };
      type: RCSAEntityActionType.GetIncidentRCSAEntity;
    }
  | {
    data: {
      data: RCSAMonitoringDetailModel;
    };
    type: RCSAEntityActionType.GetDetailRCSAMonitoring
  }
